import React from "react";

import asIcon from "./asIcon";

export default asIcon(
  ({ color }) =>
    <path fill={color} d="M57,67c0.5-0.8,0.7-1.2,0.7-2s-0.2-1.5-0.7-2L45,50l12-13c0.5-0.5,0.7-1.2,0.7-2s-0.2-1.2-0.7-1.8c-0.8-0.5-1.2-0.8-2-0.8c-0.7,0-1.5,0.2-2,0.8L38.3,48c-0.5,0.5-0.8,1.2-0.8,2s0.2,1.2,0.8,1.8l14.8,15c0.7,0.5,1.2,0.8,2,0.8C55.5,67.5,56.2,67.2,57,67z" />,
);
